import AnnuityInfo from "./AnnuityInfo";

export default AnnuityInfo;